<template>
  	<TopMenu :breadcrumbs="breadcrumbs" />
  	<div class="page-tabs">
		<router-link 
			:to="{name: 'PageTrackerHouseTasks', params: {organization_id: organization_id, house_id: house_id}}" class="page-tabs__item">
			Задания
		</router-link>
		<router-link
			:to="{name: 'PageTrackerHouseSignals', params: {organization_id: organization_id, house_id: house_id}}" class="page-tabs__item">
			Сигналы 
			<div class="page-tabs__badge" v-if="badge > 0"> {{ badge }} </div>
		</router-link>
	</div>
    <slot></slot>
</template>

<script setup>
  import TopMenu from '@/components/TopMenu.vue';
</script>

<script>
	export default {
	    name: 'InnerTemplate',
	    props: ['breadcrumbs'],
	    data: () => ({
	    }),
	    methods: {
	    },
	    computed: {
	    	house_id () {
		        return this.$route.params.house_id;
		    },
		    organization_id () {
		        return this.$route.params.organization_id;
		    },
      	badge() {
      		return this.$store.state.badge == null ? 0 : this.$store.state.badge.companies[this.organization_id].houses[this.house_id].count;
      	},
	    },
	}
</script>

<style scoped>

	.page-tabs {
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	    justify-content: flex-start;
	    gap: 5px;
	    padding: 10px 10px;
	    background-color: #fff;
	    border-radius: 8px;
	}
	.page-tabs__item {
	    border: 1px solid rgba(var(--cozh-blue-code), 0.35);
	    border-radius: 20px;
	    padding: 0px 20px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    height: 28px;
	    color: var(--cozh-blue);
	    font-weight: 600;
	    font-size: 11px;
	    text-transform: uppercase;
	    letter-spacing: 0.05em;
	    position: relative;
	}
	.page-tabs__item.router-link-exact-active {
	    background-color: var(--cozh-blue);
	    color: #fff;
	}
	.page-tabs__badge {
/*		position: absolute;*/
/*	    right: -5px;*/
/*	    top: -10px;*/
/*	    */
		transform: translateX(14px);
	    background-color: var(--cozh-red);
	    color: var(--cozh-white);
	    font-size: 10px;
	    font-weight: 500;
	    line-height: 1;
	    padding: 4px 7px;
	    border-radius: 10px;
	    min-width: 16px;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    margin-left: -8px;
	}
	.page-tabs__item.router-link-exact-active .page-tabs__badge {
	    background-color: var(--cozh-white);
	    color: var(--cozh-red);
	}

</style>